import * as React from 'react';
import { Check, CheckCircle, Clear, Event, LocalShippingOutlined } from '@mui/icons-material';
import { ContainerEventChange, ContainerHistoryEvent } from 'services/clients/watchList';

interface StatusMapping {
  icon: React.ReactNode | JSX.Element;
  text: string;
}

const shipSVG = (
  <svg
    className="fill-current"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0024 9.6605L4 12.949L7.01051 21H16.9943L20.0048 12.949L12.0024 9.6605ZM6.24809 7.14793H11.3722V8.31435L6.24809 10.2019V7.14793ZM17.7567 10.2019L12.6326 8.31435V7.14793H17.7567V10.2019ZM11.3722 5.87648H8.22653V4H11.3722V5.87648ZM15.7783 5.87648H12.6326V4H15.7783V5.87648Z"
    />
  </svg>
);

// Returns the first change that matches the key and has a different new and old value
const changed = (event: ContainerHistoryEvent, key: string): ContainerEventChange | undefined => {
  return event.changes.find(
    (c: ContainerEventChange) => c.fieldKey === key && c.newValue !== c.oldValue
  );
};

export const statusMapping = (event: ContainerHistoryEvent): StatusMapping | null => {
  if (event.eventSubtype === 'on_vessel')
    return { text: event.originalEvent.vesselName || 'On vessel', icon: shipSVG };

  if (event.eventType === 'milestone') {
    if (event.milestoneType === 'gated_out') {
      return { text: 'In transit', icon: <LocalShippingOutlined /> };
    }
    if (event.milestoneType === 'terminated')
      return { text: 'Empty returned', icon: <CheckCircle /> };
  }

  if (event.eventType === 'container_availability') {
    const { isAvailableForPickup } = event.originalEvent;

    if (event.eventSubtype === 'gated_out') {
      return { text: 'In transit', icon: <LocalShippingOutlined /> };
    }
    if (event.eventSubtype === 'terminated')
      return { text: 'Empty returned', icon: <CheckCircle /> };

    if (changed(event, 'appointmentStartDate'))
      return { text: 'Return scheduled', icon: <Event /> };

    // If the event changes includes a change to availability and the new value is available, return available
    if (isAvailableForPickup === true) {
      return { text: 'Available for pickup', icon: <Check /> };
    }

    // If the event changes includes a change to availability and the new value is not available, return not available
    if (isAvailableForPickup === false) {
      return { text: 'Not available for pickup', icon: <Clear /> };
    }
  }

  return null;
};
